import React, { useState } from "react";
import { jobInfoType } from "../../../../common/interfaces/myProfile/personalDetails/jobInfo";
import { useAppSelector } from "../../../../infra/hooks";
import DTOJobInfo from "./DTOJobInfo";
import JobInfoPresenter from "./JobInfoPresenter";
import { useTranslation } from "react-i18next";

function JobInfoController() {
  const { t } = useTranslation();
  const [jobInfo, setJobInfo] = useState<jobInfoType>({
    staffId: 0,
    hireDate: new Date(),
    departmentName: "",
    employeeType: "",
    contractType: "",
    employeeCategory: "",
    payrollType: "",
    extNo: "",
  });

  function callBackFunc(data: jobInfoType) {
    setJobInfo(data);
  }
  
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <>
      <DTOJobInfo setJobInfo={callBackFunc} />
      <JobInfoPresenter job={jobInfo} hr_view={hr_view} trans={t} />
    </>
  );
}

export default JobInfoController;
